(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cta-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperMixIt = new Swiper('.mixit-swiper', {
      slidesPerView: 1.7,
      breakpoints: {
        1024: {
          slidesPerView: 2.4
        }
      },
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        prevEl: '.mixit-swiper-prev',
        nextEl: '.mixit-swiper-next'
      },
      
    });
    function togglePrevButton(swiperInstance) {
      const prevButton = document.querySelector('.swiper-button-prev');
      const isLastSlide = swiperInstance.activeIndex === swiperInstance.slides.length - 1;
      if (isLastSlide) {
        prevButton.classList.remove('opacity-0');
      } else {
        prevButton.classList.add('opacity-0');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-with-video-slideshow"] && !Shopify.designMode) return;
  try {
    
 
  document.addEventListener("DOMContentLoaded", function () {
    // Init Swiper
    new Swiper(".video-swiper", {
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      mousewheel: {
        forceToAxis: true,
      }
    });

    // Play button logic
    /*document.querySelectorAll(".js-play-button").forEach(button => {
      button.addEventListener("click", function () {
        const wrapper = this.closest(".js-video-wrapper");
         wrapper.style.position = "relative";
    wrapper.style.paddingTop = "100%"; 
        const thumbnail = wrapper.querySelector(".js-thumbnail");
        const url = this.dataset.videoUrl;
   
        const videoIdMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/);
if (videoIdMatch) {
  const videoId = videoIdMatch[1];
  embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
} else if (url.includes("vimeo")) {
  embedUrl = url.replace("vimeo.com", "player.vimeo.com/video") + "?autoplay=1";
} else {
  embedUrl = url; // fallback
}


        // Clean up
        if (thumbnail) thumbnail.remove();
        this.remove();

        // Add iframe
        const iframe = document.createElement("iframe");
        iframe.src = embedUrl;
        iframe.className = "absolute inset-0 w-full h-full";
        iframe.frameBorder = "0";
        iframe.allow = "autoplay; fullscreen";
        iframe.allowFullscreen = true;
        wrapper.appendChild(iframe);
      });
    });*/

    /*document.querySelectorAll(".js-play-button").forEach(button => {
    button.addEventListener("click", function () {
      const wrapper = this.closest(".js-video-wrapper");
      wrapper.style.position = "relative";
      wrapper.style.paddingTop = "100%";
      const thumbnail = wrapper.querySelector(".js-thumbnail");
      const url = this.dataset.videoUrl;
      const videoType = this.dataset.videoType;

      if (thumbnail) thumbnail.remove();
      this.remove();

      if (videoType === "file") {
        // Play local video
        const video = document.createElement("video");
        video.src = url;
        video.className = "video-player absolute inset-0 w-full h-full object-cover";
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        wrapper.appendChild(video);
      } else {
        let embedUrl;
        const videoIdMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/);
        if (videoIdMatch) {
          const videoId = videoIdMatch[1];
          embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        } else if (url.includes("vimeo")) {
          embedUrl = url.replace("vimeo.com", "player.vimeo.com/video") + "&autoplay=1";

        const containerDiv = document.createElement("div");
        containerDiv.style.position = "relative";
const iframe = document.createElement("iframe");
        iframe.src = embedUrl;
        iframe.className = "video-player absolute inset-0 w-full h-full object-cover";
        iframe.frameBorder = "0";
        iframe.allow = "autoplay; fullscreen";
        iframe.allowFullscreen = true;
        wrapper.appendChild(iframe);
   
        } else {
          embedUrl = url; 
          const iframe = document.createElement("iframe");
        iframe.src = embedUrl;
        iframe.className = "absolute inset-0 w-full h-full";
        iframe.frameBorder = "0";
        iframe.allow = "autoplay; fullscreen";
        iframe.allowFullscreen = true;
        wrapper.appendChild(iframe);
        }

        
      }
    });
  });*/
  });

  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const shopLink = document.querySelector('.shop-menu-link');
  const submenu = document.querySelector('.shop-submenu');
  const otherMenuLinks = document.querySelectorAll('.menu-link');

  let submenuVisible = false;
  let submenuTimeout;

  function showSubmenu() {
    clearTimeout(submenuTimeout);
    submenu.style.display = 'block';
    submenu.style.visibility = 'visible';
     submenu.style.opacity = '1';
    submenuVisible = true;
  }

  function hideSubmenu() {
    submenuTimeout = setTimeout(() => {
      submenu.style.display = 'none';
      submenu.style.visibility = 'hidden';
     submenu.style.opacity = '0';
      submenuVisible = false;
    }, 100); 
  }

  if (shopLink && submenu) {
    shopLink.addEventListener('mouseenter', showSubmenu);
    shopLink.addEventListener('mouseleave', hideSubmenu);

    submenu.addEventListener('mouseenter', showSubmenu);
    submenu.addEventListener('mouseleave', hideSubmenu);
  }

  // Hide submenu if hovering another top-level link
  otherMenuLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      if (submenuVisible) {
        submenu.style.display = 'none';
        submenuVisible = false;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  document.querySelectorAll('.tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

      tab.classList.add('active');
      document.getElementById(tab.getAttribute('data-tab')).classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiperTestimonials = new Swiper('.swiper.testimonials', {
    slidesPerView: 1,
    spaceBetween: 8,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    },
    speed: 400,
    mousewheel: {
      forceToAxis: true,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><span></span>' + "</span>";
      },
    },
    on: {
      init: function () {
        highlightNextNext(this); // call on init
      },
      slideChangeTransitionEnd: function () {
        highlightNextNext(this); // call on slide change
      },
    }
  });

  function highlightNextNext(swiper) {
 
    swiper.slides.forEach(slide => slide.classList.remove('next-next'));


    const activeSlide = [...swiper.slides].find(slide =>
      slide.classList.contains('swiper-slide-active')
    );

    if (activeSlide) {
      //let nextNext = activeSlide.nextElementSibling?.nextElementSibling;

      let nextNext = activeSlide;
let steps = 0;

while (nextNext && steps < 2) {
  nextNext = nextNext.nextElementSibling;
  if (nextNext && !nextNext.classList.contains('swiper-slide-blank')) {
    steps++;
  }
}

   
      if (!nextNext) {
        const index = [...swiper.slides].indexOf(activeSlide);
        const total = swiper.slides.length;
        const wrappedIndex = (index + 2) % total;
        nextNext = swiper.slides[wrappedIndex];
      }

      if (nextNext) {
        nextNext.classList.add('next-next');
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-video-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  class WordRotator {
  constructor(wrapper) {
    this.wordRotateWrapper = wrapper;
    this.wordContainer = this.wordRotateWrapper.querySelector('.word-rotate-container');
    this.words = this.wordRotateWrapper.querySelectorAll('.word-rotate-text');
    this.currentWordIndex = 0;
    this.totalWords = this.words.length;
    this.ANIMATION_DURATION = 100; // ms
  }

  getWordWidth(element) {
    return element.offsetWidth;
  }

  updateWrapperWidth(index) {
    const width = this.getWordWidth(this.words[index]);
    this.wordRotateWrapper.style.width = `${width}px`;
  }

  getTranslateX(index) {
    let totalTranslate = 0;
    for (let i = 0; i < index; i++) {
      totalTranslate += this.getWordWidth(this.words[i]);
    }
    return totalTranslate;
  }

  resetToStart() {
    this.wordContainer.style.transition = 'none';
    this.wordRotateWrapper.style.transition = 'none';
    this.wordContainer.style.transform = `translateX(0)`;
    this.currentWordIndex = 0;
    this.updateWrapperWidth(this.currentWordIndex);

    // Force reflow
    this.wordContainer.offsetHeight;

    // Restore transitions
    this.wordContainer.style.transition = 'transform 200ms ease-in-out';
    this.wordRotateWrapper.style.transition = 'width 200ms ease-in-out';
  }

  rotateWords() {
    this.currentWordIndex++;

    const translateX = this.getTranslateX(this.currentWordIndex);

    this.wordContainer.style.transform = `translateX(-${translateX}px)`;
    this.updateWrapperWidth(this.currentWordIndex);

    if (this.currentWordIndex === this.totalWords - 1) {
      setTimeout(() => this.resetToStart(), this.ANIMATION_DURATION);
    }
  }

  startRotation() {
    this.rotateWords();
    if (this.currentWordIndex < this.totalWords - 1) {
      setTimeout(() => this.startRotation(), 1500);
    } else {
      setTimeout(() => {
        this.startRotation();
      }, 1500 + this.ANIMATION_DURATION);
    }
  }

  init() {
    this.updateWrapperWidth(0);
    this.wordContainer.style.transition = 'transform 200ms ease-in-out';
    this.wordRotateWrapper.style.transition = 'width 200ms ease-in-out';
    
    // Initial delay before starting
    setTimeout(() => this.startRotation(), 1500);
  }
}


  const wrappers = document.querySelectorAll('.word-rotate-wrapper');
  wrappers.forEach(wrapper => {
    const rotator = new WordRotator(wrapper);
    rotator.init();
  });



  // Existing Swiper initialization
  const swiperHoWillUMixIt = new Swiper('.swiper.howillumixit', {
    slidesPerView: 1.6,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 80,
      }
    },
    mousewheel: {
      forceToAxis: true,
    },
    centeredSlides: false,
    loop: true,
    speed: 400,
    navigation: {
      nextEl: '.howillumixit-swiper-prev',
      prevEl: '.howillumixit-swiper-next',
    },
     slideToClickedSlide: false,    
  allowTouchMove: true,          
  });

  window.addEventListener('resize', () => {
    swiperHoWillUMixIt.update();
  });

  document.querySelectorAll('.video-slideshow').forEach(slide => {
  const playBtn = slide.querySelector('button');
  const img = slide.querySelector('img');
  const video = slide.querySelector('.js-slide-video');

  if (video && playBtn) {
    playBtn.addEventListener('click', function() {
      img.style.display = 'none';
      playBtn.style.display = 'none';
      video.classList.remove('hidden');
      video.muted = true;
      video.play();

  
    });
  }
});

  document.querySelectorAll('.video-slideshow').forEach(slide => {
  const video = slide.querySelector('.js-slide-video');
  if (video) {

    ['mousedown', 'touchstart', 'click', 'focus'].forEach(eventName => {
      video.addEventListener(eventName, e => {
        console.log("video played!");
         swiperHoWillUMixIt.allowSlideNext = false;
        swiperHoWillUMixIt.allowSlidePrev = false;
        
        setTimeout(() => {
          swiperHoWillUMixIt.allowSlideNext = true;
          swiperHoWillUMixIt.allowSlidePrev = true;
        }, 2000);
      });
    });
  }
});



});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiperTestimonials = new Swiper('.swiper.testimonials', {
    slidesPerView: 1,
    spaceBetween: 8,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 16
      }
    },
    speed: 400,
    mousewheel: {
      forceToAxis: true,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"><span></span>' + "</span>";
      },
    },
    on: {
      init: function () {
        highlightNextNext(this); // call on init
      },
      slideChangeTransitionEnd: function () {
        highlightNextNext(this); // call on slide change
      },
    }
  });

  function highlightNextNext(swiper) {
 
    swiper.slides.forEach(slide => slide.classList.remove('next-next'));


    const activeSlide = [...swiper.slides].find(slide =>
      slide.classList.contains('swiper-slide-active')
    );

    if (activeSlide) {
      //let nextNext = activeSlide.nextElementSibling?.nextElementSibling;

      let nextNext = activeSlide;
let steps = 0;

while (nextNext && steps < 2) {
  nextNext = nextNext.nextElementSibling;
  if (nextNext && !nextNext.classList.contains('swiper-slide-blank')) {
    steps++;
  }
}

   
      if (!nextNext) {
        const index = [...swiper.slides].indexOf(activeSlide);
        const total = swiper.slides.length;
        const wrappedIndex = (index + 2) % total;
        nextNext = swiper.slides[wrappedIndex];
      }

      if (nextNext) {
        nextNext.classList.add('next-next');
      }
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  class WordRotator {
  constructor(wrapper) {
    this.wordRotateWrapper = wrapper;
    this.wordContainer = this.wordRotateWrapper.querySelector('.word-rotate-container');
    this.words = this.wordRotateWrapper.querySelectorAll('.word-rotate-text');
    this.currentWordIndex = 0;
    this.totalWords = this.words.length;
    this.ANIMATION_DURATION = 100; // ms
  }

  getWordWidth(element) {
    return element.offsetWidth;
  }

  updateWrapperWidth(index) {
    const width = this.getWordWidth(this.words[index]);
    this.wordRotateWrapper.style.width = `${width}px`;
  }

  getTranslateX(index) {
    let totalTranslate = 0;
    for (let i = 0; i < index; i++) {
      totalTranslate += this.getWordWidth(this.words[i]);
    }
    return totalTranslate;
  }

  resetToStart() {
    this.wordContainer.style.transition = 'none';
    this.wordRotateWrapper.style.transition = 'none';
    this.wordContainer.style.transform = `translateX(0)`;
    this.currentWordIndex = 0;
    this.updateWrapperWidth(this.currentWordIndex);

    // Force reflow
    this.wordContainer.offsetHeight;

    // Restore transitions
    this.wordContainer.style.transition = 'transform 200ms ease-in-out';
    this.wordRotateWrapper.style.transition = 'width 200ms ease-in-out';
  }

  rotateWords() {
    this.currentWordIndex++;

    const translateX = this.getTranslateX(this.currentWordIndex);

    this.wordContainer.style.transform = `translateX(-${translateX}px)`;
    this.updateWrapperWidth(this.currentWordIndex);

    if (this.currentWordIndex === this.totalWords - 1) {
      setTimeout(() => this.resetToStart(), this.ANIMATION_DURATION);
    }
  }

  startRotation() {
    this.rotateWords();
    if (this.currentWordIndex < this.totalWords - 1) {
      setTimeout(() => this.startRotation(), 1500);
    } else {
      setTimeout(() => {
        this.startRotation();
      }, 1500 + this.ANIMATION_DURATION);
    }
  }

  init() {
    this.updateWrapperWidth(0);
    this.wordContainer.style.transition = 'transform 200ms ease-in-out';
    this.wordRotateWrapper.style.transition = 'width 200ms ease-in-out';
    
    // Initial delay before starting
    setTimeout(() => this.startRotation(), 1500);
  }
}


  const wrappers = document.querySelectorAll('.word-rotate-wrapper');
  wrappers.forEach(wrapper => {
    const rotator = new WordRotator(wrapper);
    rotator.init();
  });



  // Existing Swiper initialization
  const swiperHoWillUMixIt = new Swiper('.swiper.howillumixit', {
    slidesPerView: 1.6,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 80,
      }
    },
    mousewheel: {
      forceToAxis: true,
    },
    centeredSlides: false,
    loop: true,
    speed: 400,
    navigation: {
      nextEl: '.howillumixit-swiper-prev',
      prevEl: '.howillumixit-swiper-next',
    },
     slideToClickedSlide: false,    
  allowTouchMove: true,          
  });

  window.addEventListener('resize', () => {
    swiperHoWillUMixIt.update();
  });

  document.querySelectorAll('.video-slideshow').forEach(slide => {
  const playBtn = slide.querySelector('button');
  const img = slide.querySelector('img');
  const video = slide.querySelector('.js-slide-video');

  if (video && playBtn) {
    playBtn.addEventListener('click', function() {
      img.style.display = 'none';
      playBtn.style.display = 'none';
      video.classList.remove('hidden');
      video.muted = true;
      video.play();

  
    });
  }
});

  document.querySelectorAll('.video-slideshow').forEach(slide => {
  const video = slide.querySelector('.js-slide-video');
  if (video) {

    ['mousedown', 'touchstart', 'click', 'focus'].forEach(eventName => {
      video.addEventListener(eventName, e => {
        console.log("video played!");
         swiperHoWillUMixIt.allowSlideNext = false;
        swiperHoWillUMixIt.allowSlidePrev = false;
        
        setTimeout(() => {
          swiperHoWillUMixIt.allowSlideNext = true;
          swiperHoWillUMixIt.allowSlidePrev = true;
        }, 2000);
      });
    });
  }
});



});

  } catch(e) { console.error(e); }
})();
})();
